import { NextPage, GetStaticPaths, GetStaticProps } from 'next';
import Head from 'next/head';

import { DirectionsData, DirectionDataI } from 'pages/api/directionPages';
import Gallery from 'components/layouts/Direction';

type Props = {
  item?: DirectionDataI;
  errors?: string;
};

const Index: NextPage<Props> = ({ item, errors }) => {
  if (errors) {
    return (
      <div title="Error | Next.js + TypeScript Example">
        <p>
          <span style={{ color: 'red' }}>Error:</span> {errors}
        </p>
      </div>
    );
  }

  return (
    <div>
      <Head>
        <title>{item.metaTitle}</title>
        <link rel="icon" href="/favicon.ico" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <meta name="description" content={item.metaDescription}></meta>
        <meta name="google" content="notranslate" />
        <meta property="og:title" content={item.metaTitle} />
        <meta property="og:description" content={item.metaDescription} />
        <meta
          property="og:url"
          content={'https://shamryartspace.com/directions/' + item.reflink}
        />
        <meta property="og:type" content="website" />
      </Head>
      <Gallery
        headerName={item.name}
        headerDescription={item.description}
        images={item.images}
        buttonDirectionRedirectLink={item.buttonDirectionRedirectLink}
        buttonDirectionRedirectName={item.buttonDirectionRedirectName}
      ></Gallery>
    </div>
  );
};

export default Index;

export const getStaticPaths: GetStaticPaths = async () => {
  const data = DirectionsData;
  const paths = data.map((direction) => ({
    params: { name: direction.reflink.toString() },
  }));

  return { paths, fallback: false };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  try {
    const name = params.name;
    const item = DirectionsData.find((data) => data.reflink === name);
    return { props: { item } };
  } catch (err) {
    return { props: { errors: err.message } };
  }
};

/*
  //const router = useRouter();

const { name } = router.query;
  let Direction: DirectionDataI;

  DirectionsData.map((c) => {
    if (c.reflink === name) {
      Direction = c;
    }
  });

  if (!name || !Direction) {
    return <div></div>;
  }*/
